import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { updateSuggestionStatus } from '../ui/utils/api';
import { applyToolCalls } from '../ui/utils/toolCalls/applyToolCalls';

import type { AcceptAllSuggestionsAction } from './types';

export const acceptAllSuggestionsAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => AcceptAllSuggestionsAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
		if (!suggestionById || suggestionById.size === 0) {
			return false;
		}

		// Snapshot suggestions up-front: dispatching CLEAR_SUGGESTIONS will mutate plugin state,
		// so iterating the live Map during dispatch is unsafe.
		const suggestions = Array.from(suggestionById.values());

		api?.core?.actions.execute(({ tr }) => {
			for (const suggestion of suggestions) {
				applyToolCalls({ tr, suggestion });
			}
			tr.setMeta('scrollIntoView', false);
			tr.setMeta(aiSuggestionsPluginKey, { action: 'CLEAR_SUGGESTIONS' });
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});

		const updates = suggestions.map(({ id }) => ({ id, status: 'ACTIONED' as const }));

		updateSuggestionStatus({ updates });

		return true;
	};
